import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { MRT_Row } from 'material-react-table';

import { useMoney } from '../../../currency/useMoney';
import { download, generateCsv, mkConfig } from 'export-to-csv';
import { toDinero } from '../../../currency/currencyLib';
import { KitchenTableOrder } from '../../controlKitchenApi';
import { StandardButton } from '../../../../shared/components/buttons/StandardButton';
import { LocalizedStrict } from '../../../localization/components/AppLocalized';
import { useAppLocalization } from '../../../localization/components/AppLocalizationProvider';
import { useDateTime } from '../../../localization/useDateTime';
import { StandardExportButton } from '../../../../shared/components/table/StandardExportButton';
import { useExportStamp } from '../production/components/useExportStamp';
import { useRefreshBeforeExport, withFreshRows } from '../production/components/useRefreshBeforeExport';
import type { RefreshableQuery } from '../production/components/useRefreshBeforeExport';


interface DropdownExportButtonProps {
    rowsIsSelected: boolean
    containsRows: boolean
    allRowsWithFilter: MRT_Row<KitchenTableOrder>[]
    seletecRows: MRT_Row<KitchenTableOrder>[]
    chosenStartDate: string
    chosenEndDate: string
    query: RefreshableQuery
}



export function DropdownExportButtonControlKitchen({ allRowsWithFilter, rowsIsSelected, seletecRows, containsRows, chosenStartDate, chosenEndDate, query }: DropdownExportButtonProps) {



    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const dateTimeFactory = useDateTime()

    const formattedStartDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenStartDate))
    const formattedEndDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenEndDate))
    const getExportStamp = useExportStamp()

    const moneyFactory = useMoney({})
    const { l10n } = useAppLocalization()


    const handleExportRows = (rowData: KitchenTableOrder[]) => {
        if (rowData.length === 0) return

        const exportStamp = getExportStamp()
        const csvOptions = mkConfig({
            fieldSeparator: ';',
            quoteStrings: true,
            decimalSeparator: '.',
            useBom: true,
            useKeysAsHeaders: true,
            filename: `Facilitynet-manager-control-${formattedStartDate}_${formattedEndDate}-${exportStamp.fileSuffix}`
        });

        const exportRows = rowData.map((order) => ({

            "From": order.startDate,
            "To": order.endDate,
            "Is checked-in": order?.receipt?.checkIn?.isValid,
            "Checked-in time": order?.receipt?.checkIn?.checkInTime ?? "",
            "Transaction id": order.id,
            "Card id": "",
            "Card number": "",
            "Amount": moneyFactory.format(toDinero(order.amount)),
            "Order lines": order.orderLines?.map(l => l.name).join(" \u2218 ") ?? "",
            "Transaction Time": dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(order.created)),
            "User id": order?.customer?.id ?? "",
            "Employeed id": order?.customer?.employeeId ?? "",
            "Intials": order?.customer?.initials,
            "Surname": order?.customer?.surName,
            "GivenName": order?.customer?.givenName,
            "E-mail": order?.customer?.email,
            "Department": order?.customer?.department?.name ?? "",
            "User group id": order?.customer?.userGroup?.id,
            "User group": order?.customer?.userGroup?.name ?? "",
            "Company VAT number": order.accountingCustomerParty?.vatNumber ?? "",
            "Company": order.accountingCustomerParty?.name ?? "",
            "Payment method": order.paymentDetails.method ? l10n.getStringForEnum("purchases-payment-method", order.paymentDetails.method, "") : "",
            "Sales location": "",
            "Terminal id": "",
            [exportStamp.columnTitle]: exportStamp.value,
        }))




        const csv = generateCsv(csvOptions)(exportRows);
        download(csvOptions)(csv)

    }




    // no getRowId here: a refresh can move the selection to other rows
    const [selectedOnClick, setSelectedOnClick] = useState<KitchenTableOrder[]>()

    const { exportFresh, isExporting } = useRefreshBeforeExport(query, () => {
        const freshRows = allRowsWithFilter.map((row) => row.original)
        handleExportRows(selectedOnClick ? withFreshRows(selectedOnClick, freshRows) : freshRows)
    })

    const startExport = (selected?: KitchenTableOrder[]) => {
        handleClose()
        setSelectedOnClick(selected)
        exportFresh()
    }

    return (
        <div>
            <StandardExportButton onClick={handleClick} loading={isExporting} />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <LocalizedStrict id='export-button-export-all-with-filter'>
                    <MenuItem disabled={containsRows} onClick={() => startExport()}>Export all with filter</MenuItem>
                </LocalizedStrict>
                <LocalizedStrict id='export-button-export-selected-rows'>
                    <MenuItem disabled={rowsIsSelected} onClick={() => startExport(seletecRows.map((row) => row.original))}>Export Selected rows</MenuItem>
                </LocalizedStrict>
            </Menu>
        </div>
    );
}


